import { Typography, Row, Col } from 'antd';
import { HiOutlineLightBulb } from 'react-icons/hi';
import { PiLeaf } from 'react-icons/pi';
import { FiUsers } from 'react-icons/fi';

const { Title, Paragraph } = Typography;

export const AboutPage = () => {
  
  return (
    <>
      {/* Hero Section */}
      <section className="bg-[url(/assets/images/Background.png)] bg-center bg-cover bg-no-repeat relative w-full h-[400px]">
        <div className="container relative h-full flex flex-col justify-center items-center mx-auto px-4 py-12 z-10">
          <div className="font-displayed !font-normal text-5xl lg:text-6xl text-white tracking-wider text-center">
            ABOUT US
          </div>
        </div>
      </section>
      
      {/* Company Story */}
      <section className="w-full bg-first-dark-gray pt-8 pb-18 bg-[url(/assets/images/AboutBackground.png)] bg-cover bg-center bg-no-repeat relative">
        <div className="absolute inset-0 bg-black/60 z-0"></div>
        <div className="container mx-auto px-4 relative z-10">
          <Row gutter={[48, 48]} align="middle">
            <Col md={24} lg={24}>
              <Title level={1} className="font-displayed !font-normal text-orangicide mt-4">OUR STORY</Title>
              <Paragraph className="font-orator text-white text-justify tracking-wider pb-4">
                MOD-LINK WAS BORN IN THE SNOWY MOUNTAINS OF TRUCKEE, CALIFORNIA, WHERE SNOW REMOVAL IS A PART OF LIFE. AS CONTRACTORS AND OPERATORS, WE KNOW FIRSTHAND WHICH TOOLS PULL THEIR WEIGHT AND WHICH ONES LET US DOWN. WHEN THE MARKET DIDN'T DELIVER, WE BUILT OUR OWN: CUSTOM TRUCK BEDS, STEEL RAILINGS, AND EVENTUALLY, SNOW CHAINS. OUR SHOP BECAME A PROVING GROUND WHERE NECESSITY DROVE INVENTION. AND WHERE THE INDUSTRY HAD STOPPED INNOVATING, WE DECIDED TO DO WHAT TRADESMEN DO BEST: FIX THE PROBLEM WITH OUR OWN HANDS.
              </Paragraph>
              <Paragraph className="font-orator text-white text-justify tracking-wider pb-4">
                THE CHAIN INDUSTRY GOT COMFORTABLE — SELLING THE SAME OUTDATED GEAR FOR DECADES, ASSUMING NO ONE HAD THE TIME TO RETHINK IT. BUT WE WEREN'T BUYING IT. WE SAW HARDWORKING CREWS DEALING WITH SLOW INSTALLS, WEAK HARDWARE, AND TOOLS THAT CREATED MORE PROBLEMS THAN THEY SOLVED. SO WE DID WHAT TRADESMEN DO BEST: ROLLED UP OUR SLEEVES AND BUILT SOMETHING BETTER. WITH IN-HOUSE FABRICATION AND FIELD EXPERIENCE, WE ENGINEERED SOLUTIONS THAT SAVE TIME, REDUCE FRUSTRATION, AND THRIVE IN THE HARSHEST CONDITIONS.
              </Paragraph>
              <Paragraph className="font-orator text-white text-justify tracking-wider">
                TODAY, MOD-LINK STANDS AS PROOF THAT REAL INNOVATION DOESN'T COME FROM BOARDROOMS. IT COMES FROM THE JOBSITE, THE SHOP FLOOR, AND THE HANDS OF PEOPLE WHO ACTUALLY USE THE TOOLS. THAT'S WHY OUR PRODUCTS ARE BUILT ON CRAFTSMANSHIP, REFINED BY REAL-WORLD EXPERIENCE—AND SUPPORTED BY THE KIND OF SERVICE WE'D WANT OURSELVES. WE'RE IN THIS FOR THE LONG HAUL, NOT JUST THE NEXT SALE. IF SOMETHING BREAKS, WE MAKE IT RIGHT. BECAUSE WE DON'T JUST BUILD CHAINS—WE BUILD TRUST.
              </Paragraph>
            </Col>
          </Row>
        </div>
      </section>
      
      {/* Mission & Values */}
      <section className="bg-[url(/assets/images/Background.png)] bg-center bg-cover bg-no-repeat w-full pt-16 pb-24">
        <div className="container mx-auto px-4 text-center">
          <Title level={1} className="font-displayed !font-normal text-orangicide mb-6">OUR MISSION & VALUES</Title>
          <Paragraph className="font-orator text-white !text-xl text-center max-w-2xl mx-auto !mb-16">
            At Mod-Link, we are driven by a commitment to excellence and innovation in everything we do
          </Paragraph>
                    
          {/* Mission and Values Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-18 gap-y-16 md:gap-y-16 max-w-8xl mx-auto items-stretch">
            
            <div className="relative flex flex-col items-center h-full">
              <div className="icon-badge-orangicide absolute -top-10 left-1/2 -translate-x-1/2 z-10">
                <HiOutlineLightBulb className="text-4xl" />
              </div>
              <div 
                className="relative bg-transparent border-4 border-white/50 text-white px-6 py-8 pt-10 flex flex-col items-center transition-all duration-300 hover:border-white hover:shadow-lg hover:shadow-white/20 group w-full h-full"
                style={{ clipPath: 'polygon(-20px 0, 100% 0, 100% 100%, 0 100%, 0 -20px)' }}
              >
                <div
                  className="pointer-events-none absolute top-0 left-0 bg-white/50 transition-all duration-300 group-hover:bg-white"
                  style={{ width: 20, height: 20, clipPath: 'polygon(0 0, 100% 0, 0 100%)' }}
                />
                <div
                  className="pointer-events-none absolute bottom-0 right-0 bg-white/50 transition-all duration-300 group-hover:bg-white"
                  style={{ width: 20, height: 20, clipPath: 'polygon(100% 0, 100% 100%, 0 100%)' }}
                />
                <Title level={1} className="font-displayed !font-normal text-white tracking-wider text-center !mb-4">INNOVATION</Title>
                <Paragraph className="font-orator !text-xl text-orangicide text-center !mb-0">
                  We continuously push the boundaries of what's possible in traction technology, developing new solutions that outperform traditional methods.
                </Paragraph>
              </div>
            </div>
            
            <div className="relative flex flex-col items-center h-full">
              <div className="icon-badge-orangicide absolute -top-10 left-1/2 -translate-x-1/2 z-10">
                <PiLeaf className="text-4xl" />
              </div>
              <div 
                className="relative bg-transparent border-4 border-white/50 text-white px-6 py-8 pt-10 flex flex-col items-center transition-all duration-300 hover:border-white hover:shadow-lg hover:shadow-white/20 group w-full h-full"
                style={{ clipPath: 'polygon(-20px 0, 100% 0, 100% 100%, 0 100%, 0 -20px)' }}
              >
                <div
                  className="pointer-events-none absolute top-0 left-0 bg-white/50 transition-all duration-300 group-hover:bg-white"
                  style={{ width: 20, height: 20, clipPath: 'polygon(0 0, 100% 0, 0 100%)' }}
                />
                <div
                  className="pointer-events-none absolute bottom-0 right-0 bg-white/50 transition-all duration-300 group-hover:bg-white"
                  style={{ width: 20, height: 20, clipPath: 'polygon(100% 0, 100% 100%, 0 100%)' }}
                />
                <Title level={1} className="font-displayed !font-normal text-white tracking-wider text-center !mb-4">QUALITY</Title>
                <Paragraph className="font-orator !text-xl text-orangicide text-center !mb-0">
                  We never compromise on materials or craftsmanship. Our products are built to withstand extreme conditions and provide reliable performance when it matters most.
                </Paragraph>
              </div>
            </div>
            
            <div className="relative flex flex-col items-center h-full">
              <div className="icon-badge-orangicide absolute -top-10 left-1/2 -translate-x-1/2 z-10">
                <FiUsers className="text-4xl" />
              </div>
              <div 
                className="relative bg-transparent border-4 border-white/50 text-white px-6 py-8 pt-10 flex flex-col items-center transition-all duration-300 hover:border-white hover:shadow-lg hover:shadow-white/20 group w-full h-full"
                style={{ clipPath: 'polygon(-20px 0, 100% 0, 100% 100%, 0 100%, 0 -20px)' }}
              >
                <div
                  className="pointer-events-none absolute top-0 left-0 bg-white/50 transition-all duration-300 group-hover:bg-white"
                  style={{ width: 20, height: 20, clipPath: 'polygon(0 0, 100% 0, 0 100%)' }}
                />
                <div
                  className="pointer-events-none absolute bottom-0 right-0 bg-white/50 transition-all duration-300 group-hover:bg-white"
                  style={{ width: 20, height: 20, clipPath: 'polygon(100% 0, 100% 100%, 0 100%)' }}
                />
                <Title level={1} className="font-displayed !font-normal text-white text-center !mb-4">CUSTOMER FOCUS</Title>
                <Paragraph className="font-orator !text-xl text-orangicide text-center !mb-0">
                  We work closely with our customers to understand their specific needs and challenges, developing customized solutions that help them operate more efficiently and safely.
                </Paragraph>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="w-full bg-black py-18">
        <div className="container text-center mx-auto px-4 pb-6">
          <span className="font-displayed !font-normal text-white text-4xl lg:text-5xl text-center tracking-wider block mb-12">OUR TEAM</span>          
          <div className="flex flex-wrap justify-center gap-8">            
            <div className="relative w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.5rem)]">
              <div 
                className="bg-[url(/assets/images/Background.png)] bg-right bg-no-repeat relative bg-zinc-800 border-4 border-white h-35 p-8"
                style={{
                  clipPath: 'polygon(-20px 0, 100% 0, 100% 100%, 0 100%, 0 -20px)',
                  backgroundSize: '220%'
                }}
              >
                <div
                  className="pointer-events-none absolute top-0 left-0"
                  style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(0 0, 100% 0, 0 100%)' }}
                />
                <div
                  className="pointer-events-none absolute bottom-0 right-0"
                  style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(100% 0, 100% 100%, 0 100%)' }}
                />
                <Title level={2} className="font-displayed !font-normal text-orangicide text-center">Tim Ruppert</Title>
                <div className="font-displayed !font-normal text-white text-lg mb-4">FOUNDER, CEO</div>
              </div>
            </div>            
            <div className="relative w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.5rem)]">
              <div 
                className="bg-[url(/assets/images/Background.png)] bg-center bg-no-repeat relative bg-zinc-800 border-4 border-white h-35 p-8"
                style={{
                  clipPath: 'polygon(-20px 0, 100% 0, 100% 100%, 0 100%, 0 -20px)',
                  backgroundSize: '220%'
                }}
              >
                <div
                  className="pointer-events-none absolute top-0 left-0"
                  style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(0 0, 100% 0, 0 100%)' }}
                />
                <div
                  className="pointer-events-none absolute bottom-0 right-0"
                  style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(100% 0, 100% 100%, 0 100%)' }}
                />
                <Title level={2} className="font-displayed !font-normal text-orangicide text-center">Nate Ruppert</Title>
                <div className="font-displayed !font-normal text-white text-lg mb-4">CO-FOUNDER, INVESTOR</div>
              </div>
            </div>            
            <div className="relative w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.5rem)]">
              <div 
                className="bg-[url(/assets/images/Background.png)] bg-left bg-no-repeat relative bg-zinc-800 border-4 border-white h-35 p-8"
                style={{
                  clipPath: 'polygon(-20px 0, 100% 0, 100% 100%, 0 100%, 0 -20px)',
                  backgroundSize: '220%'
                }}
              >
                <div
                  className="pointer-events-none absolute top-0 left-0"
                  style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(0 0, 100% 0, 0 100%)' }}
                />
                <div
                  className="pointer-events-none absolute bottom-0 right-0"
                  style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(100% 0, 100% 100%, 0 100%)' }}
                />
                <Title level={2} className="font-displayed !font-normal text-orangicide text-center">Gabe Deiro</Title>
                <div className="font-displayed !font-normal text-white text-lg mb-4">SALES</div>
              </div>
            </div>
            <div className="relative w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.5rem)]">
              <div 
                className="bg-[url(/assets/images/Background.png)] bg-center bg-no-repeat relative bg-zinc-800 border-4 border-white h-35 p-8"
                style={{
                  clipPath: 'polygon(-20px 0, 100% 0, 100% 100%, 0 100%, 0 -20px)',
                  backgroundSize: '220%'
                }}
              >
                <div
                  className="pointer-events-none absolute top-0 left-0"
                  style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(0 0, 100% 0, 0 100%)' }}
                />
                <div
                  className="pointer-events-none absolute bottom-0 right-0"
                  style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(100% 0, 100% 100%, 0 100%)' }}
                />
                <Title level={2} className="font-displayed !font-normal text-orangicide text-center">JV Barros</Title>
                <div className="font-displayed !font-normal text-white text-lg mb-4">FINANCE & OPERATIONS</div>
              </div>
            </div>
            <div className="relative w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.5rem)]">
              <div 
                className="bg-[url(/assets/images/Background.png)] bg-top bg-no-repeat relative bg-zinc-800 border-4 border-white h-35 p-8"
                style={{
                  clipPath: 'polygon(-20px 0, 100% 0, 100% 100%, 0 100%, 0 -20px)',
                  backgroundSize: '220%'
                }}
              >
                <div
                  className="pointer-events-none absolute top-0 left-0"
                  style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(0 0, 100% 0, 0 100%)' }}
                />
                <div
                  className="pointer-events-none absolute bottom-0 right-0"
                  style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(100% 0, 100% 100%, 0 100%)' }}
                />
                <Title level={2} className="font-displayed !font-normal text-orangicide text-center">Ayden Garbarino</Title>
                <div className="font-displayed !font-normal text-white text-lg mb-4">DESIGNER / R&D</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Product Lines Section */}
      <section>
        <div className="container w-full max-w-8xl mx-auto px-6 md:pb-8">
          <div className="font-displayed !font-normal text-white text-5xl tracking-wider pt-12 !mb-8">
            OUR PRODUCT LINES
          </div>

          {/* 1. TIRE CHAINS */}
          <div className="mb-20">
            <Title level={1} className="font-displayed !font-normal text-orangicide tracking-wider">
              TIRE CHAINS
            </Title>
            <Paragraph className="font-orator text-white !text-lg text-justify tracking-wider leading-8">
              The tire chain market got lazy, dominated by legacy brands charging a premium without offering better service than the cheap imports. We weren't impressed. As contractors and snow operators, we needed something better: chains that were tougher, smarter, and backed by people who actually care. So we built them. Mod-Link chains combine rugged durability, real-world performance, and support from a team that knows what it's like to work in your boots.
            </Paragraph>
          </div>

          {/* 2. FABRICATION */}
          <div className="mb-20">
            <Title level={1} className="font-displayed !font-normal text-orangicide tracking-wider">
              FABRICATION
            </Title>
            <Paragraph className="font-orator text-white !text-lg text-justify tracking-wider leading-8">
              When off-the-shelf solutions didn't cut it, we used our skills and resourcefulness to create our own. From precision-built truck beds to custom tool mounts, our in-house shop became a testing ground for turning ideas into ironclad reality. It's where creative problem-solving meets real-world utility, proof that grit and ingenuity still build the best tools.
            </Paragraph>
          </div>

          {/* 3. R&D / INNOVATION */}
          <div className="mb-20">
            <Title level={1} className="font-displayed !font-normal text-orangicide tracking-wider">
              R&D / INNOVATION
            </Title>
            <Paragraph className="font-orator text-white !text-lg text-justify tracking-wider leading-8">
              Innovation is at the core of Mod-Link. We're constantly pushing the boundaries of what's possible in traction chain technology and field equipment. From lighter, stronger materials to smarter, faster installs, our team is always in the lab or the shop testing, iterating, and improving. Every product we develop is shaped by real-world demands—our own and those of the operators we serve. This relentless pursuit of better design keeps our customers ahead of the curve and ready for whatever winter throws their way.
            </Paragraph>
          </div>
        </div>
      </section>

      {/* 8 - Our Family of Brands Section */}
      <section className="bg-[url(/assets/images/Background.png)] bg-center bg-cover bg-no-repeat pb-12">
        <div className="container mx-auto">
          <div className="font-displayed !font-normal text-white text-center text-4xl md:text-5xl uppercase py-12">
            OUR FAMILY OF BRANDS
          </div>
          
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 pb-6">
            {/* Logos das marcas */}
            <a 
              href="https://ruppertinc.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-[100px] h-[70px] md:w-[180px] md:h-[80px] flex items-center justify-center hover:opacity-80 transition-opacity"
            >
              <img 
                src="/assets/logos/RuppertLogo.svg" 
                alt="Ruppert Logo" 
                className="max-w-full max-h-full" 
              />
            </a>
            <a 
              href="https://estabrookinc.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-[100px] h-[70px] md:w-[180px] md:h-[80px] flex items-center justify-center hover:opacity-80 transition-opacity"
            >
              <img 
                src="/assets/logos/EstabrookLogo.svg" 
                alt="Estabrook Logo" 
                className="max-w-full max-h-full" 
              />
            </a>
            <a 
              href="https://modlink.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-[100px] h-[70px] md:w-[180px] md:h-[80px] flex items-center justify-center hover:opacity-80 transition-opacity"
            >
              <img 
                src="/assets/logos/ModLinkLogo.svg" 
                alt="Modlink Logo" 
                className="max-w-full max-h-full"
              />
            </a>
            <div className="w-[100px] h-[70px] md:w-[180px] md:h-[80px] flex items-center justify-center">
              <img 
                src="/assets/logos/SnowSyncLogo.svg" 
                alt="Snow Sync Logo" 
                className="max-w-full max-h-full" 
              />
            </div>
            <div className="w-[100px] md:w-[150px] h-[70px] md:mt-2 flex items-center justify-center">
              <img 
                src="/assets/logos/asrLogo.svg" 
                alt="ASR Logo" 
                className="max-w-full max-h-full"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}; 